import React from 'react';
import { Navigation } from './components/Navigation';
import { HeroSection } from './components/sections/HeroSection';
import { ProblemSection } from './components/sections/ProblemSection';
import { FindingsSection } from './components/sections/FindingsSection';
import { KeyFindingsSection } from './components/sections/KeyFindingsSection';
import { ResearchFoundationSection } from './components/sections/ResearchFoundationSection';
import { ResearchersSection } from './components/sections/ResearchersSection';
import { JoinResearchSection } from './components/sections/JoinResearchSection';
import { AboutSection } from './components/sections/AboutSection';
import { GridPattern } from './components/ui/GridPattern';
export function App() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80; // Account for fixed nav height
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };
  return <main className="min-h-screen w-full bg-[#B5EAD7] relative text-[#1A3D3A]" style={{
    fontFamily: "'DM Sans', sans-serif"
  }} data-id="element-0">
      <GridPattern data-id="element-1" />

      <Navigation data-id="element-2" />

      <HeroSection data-id="element-3" />
      <ProblemSection data-id="element-4" />
      <FindingsSection data-id="element-5" />
      <KeyFindingsSection data-id="element-6" />
      <ResearchFoundationSection data-id="element-7" />
      <JoinResearchSection data-id="element-8" />
      <AboutSection data-id="element-9" />
      <ResearchersSection data-id="element-10" />

      <footer className="bg-[#0D2926] px-[60px] py-[80px]" data-id="element-11">
        <div className="max-w-[1400px] mx-auto" data-id="element-12">
          <div className="flex flex-col md:flex-row justify-between items-start mb-[60px]" data-id="element-13">
            <div className="mb-8 md:mb-0" data-id="element-14">
              <div className="text-[#C5F467] mb-3" style={{
              fontFamily: "'Cormorant Garamond', serif",
              fontSize: '32px',
              fontWeight: 600
            }} data-id="element-15">
                CofounderFit
              </div>
              <p className="text-white max-w-[300px]" style={{
              fontFamily: "'DM Sans', sans-serif",
              fontSize: '14px',
              fontWeight: 400,
              lineHeight: 1.6,
              opacity: 0.5
            }} data-id="element-16">
                Researching What Makes Business
                <br data-id="element-17" />
                Partnerships Succeed
              </p>
            </div>
            <div className="flex gap-20" data-id="element-18">
              <div data-id="element-19">
                <h3 className="text-white mb-6" style={{
                fontFamily: "'DM Sans', sans-serif",
                fontSize: '12px',
                fontWeight: 400,
                letterSpacing: '2px',
                opacity: 0.4
              }} data-id="element-20">
                  RESEARCH
                </h3>
                <div className="space-y-4" data-id="element-21">
                  <button onClick={() => scrollToSection('research-foundation')} className="block text-left text-white hover:text-white transition-colors focus:outline-none focus:ring-3 focus:ring-[#C5F467] focus:ring-offset-2 focus:ring-offset-[#0D2926] rounded" style={{
                  fontFamily: "'DM Sans', sans-serif",
                  fontSize: '14px',
                  fontWeight: 400,
                  opacity: 0.7
                }} data-id="element-22">
                    Research Foundation
                  </button>
                  <button onClick={() => scrollToSection('key-findings')} className="block text-left text-white hover:text-white transition-colors focus:outline-none focus:ring-3 focus:ring-[#C5F467] focus:ring-offset-2 focus:ring-offset-[#0D2926] rounded" style={{
                  fontFamily: "'DM Sans', sans-serif",
                  fontSize: '14px',
                  fontWeight: 400,
                  opacity: 0.7
                }} data-id="element-23">
                    Key Findings
                  </button>
                  <button onClick={() => scrollToSection('research-foundation')} className="block text-left text-white hover:text-white transition-colors focus:outline-none focus:ring-3 focus:ring-[#C5F467] focus:ring-offset-2 focus:ring-offset-[#0D2926] rounded" style={{
                  fontFamily: "'DM Sans', sans-serif",
                  fontSize: '14px',
                  fontWeight: 400,
                  opacity: 0.7
                }} data-id="element-24">
                    Study
                  </button>
                </div>
              </div>
              <div data-id="element-25">
                <h3 className="text-white mb-6" style={{
                fontFamily: "'DM Sans', sans-serif",
                fontSize: '12px',
                fontWeight: 400,
                letterSpacing: '2px',
                opacity: 0.4
              }} data-id="element-26">
                  COMPANY
                </h3>
                <div className="space-y-4" data-id="element-27">
                  <button onClick={() => scrollToSection('about')} className="block text-left text-white hover:text-white transition-colors focus:outline-none focus:ring-3 focus:ring-[#C5F467] focus:ring-offset-2 focus:ring-offset-[#0D2926] rounded" style={{
                  fontFamily: "'DM Sans', sans-serif",
                  fontSize: '14px',
                  fontWeight: 400,
                  opacity: 0.7
                }} data-id="element-28">
                    About
                  </button>
                  <a href="mailto:info@cofounder.fit" className="block text-white hover:text-white transition-colors focus:outline-none focus:ring-3 focus:ring-[#C5F467] focus:ring-offset-2 focus:ring-offset-[#0D2926] rounded" style={{
                  fontFamily: "'DM Sans', sans-serif",
                  fontSize: '14px',
                  fontWeight: 400,
                  opacity: 0.7
                }} data-id="element-29">
                    Contact
                  </a>
                  <a href="#" className="block text-white hover:text-white transition-colors focus:outline-none focus:ring-3 focus:ring-[#C5F467] focus:ring-offset-2 focus:ring-offset-[#0D2926] rounded" style={{
                  fontFamily: "'DM Sans', sans-serif",
                  fontSize: '14px',
                  fontWeight: 400,
                  opacity: 0.7
                }} data-id="element-30">
                    Privacy
                  </a>
                </div>
              </div>
              <div data-id="element-31">
                <h3 className="text-white mb-6" style={{
                fontFamily: "'DM Sans', sans-serif",
                fontSize: '12px',
                fontWeight: 400,
                letterSpacing: '2px',
                opacity: 0.4
              }} data-id="element-32">
                  CONTACT
                </h3>
                <div className="space-y-4" data-id="element-33">
                  <a href="mailto:info@cofounder.fit" className="block text-white hover:text-white transition-colors focus:outline-none focus:ring-3 focus:ring-[#C5F467] focus:ring-offset-2 focus:ring-offset-[#0D2926] rounded" style={{
                  fontFamily: "'DM Sans', sans-serif",
                  fontSize: '14px',
                  fontWeight: 400,
                  opacity: 0.7
                }} data-id="element-34">
                    info@cofounder.fit
                  </a>
                  <p className="text-white" style={{
                  fontFamily: "'DM Sans', sans-serif",
                  fontSize: '14px',
                  fontWeight: 400,
                  opacity: 0.7
                }} data-id="element-35">
                    24 East 22nd St, Fl 4<br data-id="element-36" />
                    New York, NY 10010
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="border-t border-white/10 pt-10 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-37">
            <p className="text-white" style={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: '13px',
            fontWeight: 400,
            opacity: 0.4
          }} data-id="element-38">
              © 2025 CofounderFit. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </main>;
}